<template>
    <div
        class="relative flex items-center w-full col-span-1 px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div
                    class="flex justify-between"
                    @click="show = !show"
                    v-show="show"
                >
                    <h2
                        ref="scrollToMe"
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ moyen.designation }}
                    </h2>
                    <div @click="removeHardware">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <base-input
                        placeholder="Désignation"
                        v-model="moyen.designation"
                        :hasError="$v.moyen.designation.$error"
                        :errorMessage="
                            errorMessage('Désignation', $v.moyen.designation)
                        "
                        @blur="$v.moyen.designation.$touch()"
                    />
                    <base-number-input
                        label="Quantité"
                        v-model="moyen.nombre"
                        :hasError="$v.moyen.nombre.$error"
                        :errorMessage="errorMessage('Nombre', $v.moyen.nombre)"
                        @blur="$v.moyen.nombre.$touch()"
                    />
                    <base-input
                        placeholder="Caracteristique"
                        v-model="moyen.caracteristique"
                        :hasError="$v.moyen.caracteristique.$error"
                        :errorMessage="
                            errorMessage(
                                'Caracteristique',
                                $v.moyen.caracteristique
                            )
                        "
                        @blur="$v.moyen.caracteristique.$touch()"
                    />
                    <div class="mt-10 ml-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >État</label
                        >
                        <radio-box
                            label="Neuf"
                            name="etat"
                            :value="moyen.etat"
                            @change="payload => (moyen.etat = payload)"
                        />
                        <radio-box
                            class="ml-6"
                            label="Occasion"
                            name="etat"
                            :value="moyen.etat"
                            @change="payload => (moyen.etat = payload)"
                        />
                    </div>
                    <base-number-input
                        :isCurrency="true"
                        label="Prix Unitaire (HT)"
                        v-model="moyen.prix"
                        :hasError="$v.moyen.prix.$error"
                        :errorMessage="
                            errorMessage('Prix en DH', $v.moyen.prix)
                        "
                        @blur="$v.moyen.prix.$touch()"
                    />

                    <base-input
                        placeholder="Nom du fournisseur"
                        v-model="moyen.nomFournisseur"
                        :hasError="$v.moyen.nomFournisseur.$error"
                        :errorMessage="
                            errorMessage(
                                'Nom du fournisseur',
                                $v.moyen.nomFournisseur
                            )
                        "
                        @blur="$v.moyen.nomFournisseur.$touch()"
                    />
                    <div class="mt-10 ml-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Origine</label
                        >
                        <radio-box
                            label="Local"
                            name="origine"
                            :value="moyen.origine"
                            @change="payload => (moyen.origine = payload)"
                        />
                        <radio-box
                            class="ml-6"
                            name="origine"
                            label="Étranger"
                            :value="moyen.origine"
                            @change="payload => (moyen.origine = payload)"
                        />
                    </div>

                    <div class="flex justify-end mt-4 ">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeHardware"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioBox from "@/components/forms/Toggles/radioBox";
import IconTrash from "@/components/icons/trash";
import {
    required,
    integer,
    decimal,
    minValue,
    minLength,
    maxLength
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToRef } from "@/mixins/scrollToMixin.js";

export default {
    components: { RadioBox, IconTrash },
    props: {
        data: {
            type: Object
        },

        title: {
            type: String
        }
    },

    mixins: [errorMessage, scrollToRef],

    validations: {
        moyen: {
            prix: { required, decimal, minValue: minValue(0) },
            designation: { minLength: minLength(3), maxLength: maxLength(75) },
            nombre: { integer, minValue: minValue(1) },
            caracteristique: {
                minLength: minLength(3),
                maxLength: maxLength(150)
            },
            nomFournisseur: {
                minLength: minLength(3),
                maxLength: maxLength(75)
            }
        }
    },
    data() {
        return {
            moyen: this.data,
            show: false,
            name: "Matériel Informatique 2"
        };
    },
    methods: {
        addTechHardware() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch("EtudeTechnique/addITMO", this.moyen);
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        removeHardware() {
            this.$emit("remove", this.moyen.id);
        }
    }
};
</script>

<style></style>
